import { render } from "./component-tqtr.vue?vue&type=template&id=72546239"
import script from "./component-tqtr.vue?vue&type=script&lang=js"
export * from "./component-tqtr.vue?vue&type=script&lang=js"

import "./component-tqtr.vue?vue&type=style&index=0&id=72546239&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__